import React from 'react';
import './index.css';

import { EnrollProvider } from './context/EnrollContext';
import EnrollModal          from './components/EnrollModal';
import Navbar               from './components/Navbar';
import Footer               from './components/Footer';
import { UrgencyBanner, ProofStrip } from './components/UI';

import Hero          from './sections/Hero';
import Problem       from './sections/Problem';
import Outcomes      from './sections/Outcomes';
import CourseDetails from './sections/CourseDetails';
import Curriculum    from './sections/Curriculum';
import Tools         from './sections/Tools';
import Mentor        from './sections/Mentor';
import Testimonials  from './sections/Testimonials';
import Pricing       from './sections/Pricing';
import FAQ           from './sections/FAQ';
import FinalCTA      from './sections/FinalCTA';

export default function App() {
  return (
    <EnrollProvider>
      <UrgencyBanner />
      <Navbar />
      <main>
        <Hero />
        <ProofStrip />
        <Problem />
        <Outcomes />
        <CourseDetails />
        <Curriculum />
        <Tools />
        <Mentor />
        <Testimonials />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <EnrollModal />
    </EnrollProvider>
  );
}
